import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import Page from '../../components/page/page';
import Intro from '../../components/intro/intro';
import Help from '../../components/help/help';
import Partners from '../../components/partners/partners';
import Social from '../../components/social/social';
import Insurers from '../../components/insurers/insurers';

interface IInsurersProps extends WithTranslation {}

const InsurersPage = (props: IInsurersProps) => {
    const { t } = props;
    const pageContent = (
        <>
            <div className="insurers-component">
                <Intro />
            </div>
            <div className="insurers-component no-border">
                <Insurers />
            </div>
            <div className="insurers-component">
                <Help />
            </div>
            <div className="insurers-component">
                <Partners />
            </div>
            <div className="insurers-component">
                <Social />
            </div>
        </>
    );
    return <Page pageTitle={t('insurers_title')} pageContent={pageContent} />;
};

export default withTranslation()(InsurersPage);
